import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { PARTICIPATION_UPDATED_MESSAGE_TYPE } from "../utils/participationNotificationAction";

const queryKeyIncludes = (queryKey: readonly unknown[], value: string) =>
  queryKey.includes(value);

/**
 * Refreshes open event and activity screens after a push RSVP action.
 */
export const ParticipationPushSync = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleServiceWorkerMessage = (event: MessageEvent) => {
      if (event.data?.type !== PARTICIPATION_UPDATED_MESSAGE_TYPE) {
        return;
      }

      const entityId =
        typeof event.data.entityId === "string" ? event.data.entityId : "";
      const entityType = event.data.entityType;

      void queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey;
          if (!Array.isArray(key)) return false;
          if (entityId && queryKeyIncludes(key, entityId)) return true;
          if (entityType === "EVENT") {
            return queryKeyIncludes(key, "events") || queryKeyIncludes(key, "event");
          }
          if (entityType === "ACTIVITY") {
            return (
              queryKeyIncludes(key, "activities") ||
              queryKeyIncludes(key, "activity")
            );
          }
          return false;
        },
      });
    };

    navigator.serviceWorker?.addEventListener(
      "message",
      handleServiceWorkerMessage,
    );

    return () => {
      navigator.serviceWorker?.removeEventListener(
        "message",
        handleServiceWorkerMessage,
      );
    };
  }, [queryClient]);

  return null;
};
